/**
 * Beschriftung der Positionsauswahl (#158 F1) — die eine Stelle für alle Auswahllisten der Maske
 * (Bedarf „Position", Besetzung „Position", „Position zuordnen…", Anzeige „über Bedarf").
 *
 * Format „Stufe · Satz · n PT"; sind danach Beschriftungen noch gleich, werden sie in
 * Listenreihenfolge durchnummeriert („(1)", „(2)"). Rein, ohne React — Texte kommen als Funktionen.
 */
import type { MaskePosition } from '@projektverwaltung/shared';

export type PositionFuerAuswahl = Pick<
  MaskePosition,
  'beauftragte_position_id' | 'stufe' | 'preis' | 'preis_einheit' | 'anzahl_pt'
>;

export type AuswahlTexte = {
  /** z. B. „120 € /h", ohne Satz „—". */
  preis: (preis: number | null, einheit: MaskePosition['preis_einheit']) => string;
  /** z. B. „60 PT", ohne PT „— PT". */
  pt: (pt: number | null) => string;
};

export function positionOptionen(
  positionen: readonly PositionFuerAuswahl[],
  texte: AuswahlTexte,
): { value: string; label: string }[] {
  const roh = positionen.map((p) => ({
    value: p.beauftragte_position_id,
    label: `${p.stufe} · ${texte.preis(p.preis, p.preis_einheit)} · ${texte.pt(p.anzahl_pt)}`,
  }));
  const anzahl = new Map<string, number>();
  for (const o of roh) anzahl.set(o.label, (anzahl.get(o.label) ?? 0) + 1);
  const laufend = new Map<string, number>();
  return roh.map((o) => {
    if ((anzahl.get(o.label) ?? 0) < 2) return o;
    const nr = (laufend.get(o.label) ?? 0) + 1;
    laufend.set(o.label, nr);
    return { value: o.value, label: `${o.label} (${nr})` };
  });
}
